import ClientPassengerInterface from '../../interfaces/client/Passenger'

export const UPDATE_BOOKING = 'UPDATE_BOOKING'

export default (passengers: ClientPassengerInterface[], flightId: string) => ({
  type: UPDATE_BOOKING,
  passengers,
  flightId,
})
